import { Injectable } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { defer, from, Observable } from 'rxjs';
import { filter, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { UserContextSupplier } from '../supplier';

@Injectable()
export class KeycloakUserSupplier extends UserContextSupplier {
	private _userProfile$: Observable<KeycloakProfile>;

	constructor(private readonly keycloakService: KeycloakService) {
		super();
		// O UserService é criado durante os APP_INITIALIZERs, em paralelo com o keycloak.init: pedir o perfil
		// antes do login terminar gerava "The user profile was not loaded as the user is not logged in"
		// (e o erro ficava guardado no shareReplay). Aqui espera o Keycloak ficar pronto/autenticado.
		this._userProfile$ = defer(() => from(this.keycloakService.isLoggedIn())).pipe(
			switchMap((loggedIn) =>
				loggedIn
					? from(this.keycloakService.loadUserProfile())
					: this.keycloakService.keycloakEvents$.pipe(
						filter((event) => event.type === KeycloakEventType.OnAuthSuccess || event.type === KeycloakEventType.OnReady),
						take(1),
						switchMap(() => from(this.keycloakService.loadUserProfile())),
					),
			),
			shareReplay(1),
		);
	}

	username$(): Observable<string> {
		return this._userProfile$.pipe(map(({ username }) => username));
	}

	profile$(): Observable<KeycloakProfile> {
		return this._userProfile$;
	}
}
